<!-- <div class="bg-red w-100 h-100"> Email popup</div> -->
<div
    class="modal fade show" 
    [ngClass]="{'expanded': isExpanded}"
    id="ms-dynamic-modal" 
    tabindex="-1" 
    aria-labelledby="ms-dynamic-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class="d-flex w-100">
        
                <div class="flex-fill" >
                  <h3 class="modal-title mb-0">{{ modalTitle }}</h3>
                  <p>{{ modalTitleLabel }}</p>
                </div>

                <div class="btns-header">
                  <button 
                      class="header-icon close p-0 m-0" 
                      (click)="close()" 
                      aria-label="Close"
                  ><i class="fas fa-times" 
                        title="Close Popup"
                    ></i>
                  </button>
                  <button class="close header-icon expand-modal p-0 m-0" (click)="isExpanded = !isExpanded">
                    <i 
                        class="fas ms-2 me-2" 
                        [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                        [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                    ></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="created-orders-grid">
              @if (gridConfig) {
              <inavista-grid
                  [config]="gridConfig"
                  (hyperlinkClick)="onHyperlinkClick($event)" />
              } @else {
              <p>No adjustment order was created.</p>
              }
            </div>
          </div>
          <div class="modal-footer p-0">
              <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
          </div>
        </div>
    </div>
</div>


@if (linkedPopupData) {
<app-linked-popup-opener
   
    [data]="linkedPopupData"
    (onPopupClose)="linkedPopupData = null;"
></app-linked-popup-opener>
}
